<template>
    <div class="modal-overlay">
        <transition name="modal-expand">
            <div v-if="isVisible" class="products-modal" @click.stop>
                <div class="modal-content" @click.stop> <!-- Stop the click event from propagating to the overlay -->
                    <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
                    <h2>{{ isEdit ? `Edit ${$labels.product}` : `Add New ${$labels.product}` }}</h2>

          <div class="add">
            <form @submit.prevent="submit">

                <div class="form-group">
                  <label for="aircraft">Aircraft:</label>
                  <select
                    class="form-control rounded"
                    id="aircraft"
                    name="aircraft"
                    v-model="form.ac_id"
                  >
                    <option value="" disabled>Select Aircraft</option>
                    <option
                      v-for="aircraft in aircrafts"
                      :key="aircraft.aircraft_id"
                      :value="aircraft.aircraft_id"
                    >
                      {{ aircraft.name }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="specific">Specific:</label>
                  <select
                    class="form-control rounded"
                    id="specific"
                    name="specific"
                    v-model="form.spec_id"
                  >
                    <option :value="null" disabled>Select Specific</option>
                    <option
                      v-for="specific in specifics"
                      :key="specific.specific_id"
                      :value="specific.specific_id"
                    >
                      {{ specific.name }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label for="course-code">Code:</label>
                  <input
                    type="text"
                    class="form-control rounded"
                    id="course-code"
                    name="course-code"
                    placeholder="Enter Course Code"
                    v-model="form.product_code"
                  />
                </div>

                <div v-if="ENABLE_ASSESSMENT" class="form-group">
                  <label for="assessments">No of Assessments:</label>
                  <select class="form-control rounded" id="assessments" name="assessments"
                      v-model="form.assessment_count">
                      <option value="" disabled selected>Select Number of Assessments</option>
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                  </select>
                </div>

                <div v-if="suggestedProjectName">
                  <p style="text-align: center;">
                    <b>Suggested Name: </b> {{ suggestedProjectName }}
                  </p>
                </div>

                <div class="form-group">
                  <label for="product-name">Name:</label>
                  <input
                    type="text"
                    class="form-control rounded"
                    id="product-name"
                    name="product-name"
                    placeholder="Practical Element Name"
                    v-model="form.name"
                  />
                </div>

                <!-- <div class="form-group">
                  <label for="pass-rate">Pass Rate (%):</label>
                  <input
                    type="number"
                    class="form-control rounded"
                    id="pass-rate"
                    name="pass-rate"
                    min="0"
                    max="100"
                    v-model.number="form.pass_rate"
                  />
                </div> -->

              <div v-if="showAlert" class="alert alert-danger error-message" role="alert">
                <div v-if="errorMessage">{{ errorMessage }}</div>
              </div>

              <div>
                <button class="btn btn-primary rounded" style="width: 250px;" type="submit">
                  {{ isEdit ? `Update ${$labels.product}` : `Add ${$labels.product}` }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { ENABLE_ASSESSMENT as ENABLE_ASSESSMENT_FLAG } from '@/config/featureFlags';

export default {
    props: {
        products: Array,
        product: { type: Object, default: null }, // null = Add mode
        mode: { type: String, default: "add" }
    },
    data() {
      return {
        aircrafts: [],
        specifics: [],
        selectedBusiness: null,
        documents: [],
        form: {
            ac_id: "",        // required
            spec_id: null,    // optional
            name: "",         // required
            product_code: "",  // optional
            assessment_count: "",
            pass_rate: 50,
        },
        files: {
            cover: null,
            revisions: null,
            description: null,
            instructions: null,
            validation: null
        },
        showAlert: false,
        errorMessage: "",
        isVisible: false,
      };
    },
    computed: {
      ENABLE_ASSESSMENT() {
        return ENABLE_ASSESSMENT_FLAG;
      },
      isEdit() {
        return this.mode === "edit";
      },
      suggestedProjectName() {
        if (!this.form.ac_id || !this.form.spec_id) return "";

        const aircraft = this.aircrafts.find(a => a.aircraft_id === this.form.ac_id);
        const specific = this.specifics.find(s => s.specific_id === this.form.spec_id);

      if (!aircraft || !specific) return "";
      return `${aircraft.name} ${specific.name} Practical Training`;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },

    async fetchData() {
      try {
        const token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };

        let response = await axios.get("/api/aircraft", { headers });
        this.aircrafts = response.data.sort((a, b) => a.name.localeCompare(b.name));

        response = await axios.get("/api/specifics", { headers });
        this.specifics = response.data.sort((a, b) => a.name.localeCompare(b.name));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    handleFileUpload(type, event) {
      const file = event.target.files?.[0];
      if (file && file.type === "application/pdf") {
        this.files[type] = file;
        this.showAlert = false;
        this.errorMessage = "";
      } else {
        this.files[type] = null;
        this.errorMessage = "Please upload a valid PDF file.";
        this.showAlert = true;
      }
    },

    async uploadPdf(productId) {
      // If user didn't pick any files, just skip
      const hasAnyFile = Object.values(this.files).some(f => !!f);
      if (!hasAnyFile) return;

      const formData = new FormData();
      formData.append("product_id", productId);

      for (const type in this.files) {
        const file = this.files[type];
        if (file) {
          formData.append("files[]", file);
          formData.append("file_types[]", type);
        }
      }

      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      };

      const response = await axios.post("/api/documents/batch", formData, { headers });
      if (response.status !== 200) {
        throw new Error("Failed to upload PDF.");
      }
    },

    validate() {
      this.showAlert = false;
      this.errorMessage = "";

      if (!this.form.ac_id) {
        this.errorMessage = "Please select an aircraft.";
        this.showAlert = true;
        return false;
      }

      if (!this.form.name || !this.form.name.trim()) {
        this.errorMessage = "Please enter a Practical Element name.";
        this.showAlert = true;
        return false;
      }

      return true;
    },

    async submit() {
      if (!this.validate()) return;

      // Optional duplicate check (based on name + aircraft + specific)
      // Tweak to match your real uniqueness rules.
      const name = this.form.name.trim().toLowerCase();
      const isDuplicate = this.products.some(p => {
        const sameName = (p.name || "").trim().toLowerCase() === name;
        const sameAc = p.ac_id === this.form.ac_id;
        const sameSpec = (p.spec_id ?? null) === (this.form.spec_id ?? null);
        const isSelf = this.isEdit && p.product_id === this.product?.product_id;
        return sameName && sameAc && sameSpec && !isSelf;
      });

      if (isDuplicate) {
        window.alert(`A ${this.$labels.product} with these details already exists`);
        return;
      }

      try {
        const token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };

        let response;

        if (this.isEdit) {
          // PUT update
          response = await axios.put(`/api/products/${this.product.product_id}`, this.form, { headers });
        } else {
          // POST add
          response = await axios.post(`/api/products`, this.form, { headers });
        }

        if (response.status === 200 || response.status === 201) {
          const savedProduct = response.data;

          // upload PDFs (after save)
          await this.uploadPdf(savedProduct.product_id);

          window.alert(`Practical Element ${this.isEdit ? "updated" : "added"} successfully`);
          this.$emit("saved"); // parent can refresh list
          this.close();
        } else {
          this.errorMessage = "Practical Element save failed.";
          this.showAlert = true;
        }
      } catch (error) {
        console.error("Error saving Practical Element:", error);
        this.errorMessage =
          error.response?.data?.message ||
          error.message ||
          "An unexpected error occurred";
        this.showAlert = true;
      }
    },
    async fetchPdfs() {
      try {
        if (!this.isEdit || !this.product.product_id) return;
        const token = localStorage.getItem('token');
        if (!token) {
          console.error('Unauthorized');
          return;
        }

        const headers = { Authorization: `Bearer ${token}` };
        const response = await axios.get(`/api/products/${this.product.product_id}/documents`, { headers });

        if (response.status === 200) {
          const docsArray = response.data;

          // Map to easily access by type
          this.documents = docsArray.reduce((acc, doc) => {
            acc[doc.file_type] = doc;
            return acc;
          }, {});

          console.log('Mapped documents:', this.documents);
        }
      } catch (error) {
        console.error('Error retrieving Documents:', error);
      }
    },
  },

  async mounted() {
    this.isVisible = true;
    await this.fetchData();

    // Prefill for edit mode
    if (this.isEdit && this.product) {
      this.form = {
        ...this.form,
        ...this.product,
        // ensure empty spec becomes null (helps select binding)
        spec_id: this.product.spec_id ?? null,
        pass_rate: this.product.pass_rate ?? 50
      };
      await this.fetchPdfs();
    }
  }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0px;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100vh;
    z-index: 1;
}

.products-modal {
    background-color: #ffffff;
    overflow-y: auto;
    /* Enables vertical scrolling if needed */
    margin-top: 25px;
    max-height: 95vh;
    min-width: min(900px, 75%);
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    position: fixed;
    display: flex;
    flex-direction: column;
    overflow-wrap: break-word;
    padding: 20px;
    z-index: 1002;
}

.modal-content {
    border: white;
    padding: 15px;
    border: 1px solid #dddddd;
    border-radius: 3px;
}

.saveButton {
    background-color: #0055b1;
    color: #ffffff;
    font-size: 14px;
    padding: 10px;
    border: 1px solid #0a407a;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: auto;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    width: 180px;
    margin-left: 30px;
}

.saveButton:hover {
    background-color: rgb(1, 40, 82);
}

h2 {
    font-size: 30px;
    margin-bottom: 20px;
    margin-left: 25px;
}

.alert-danger {
    color: #ff0019;
    background-color: #f8d7da;
    border: 1px solid #e6b0b6;
}

.alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 0rem;
    border: 1px solid transparent;
    border-radius: .25rem;
}

.form-group {
    display: flex;
    align-items: top;
    margin-bottom: 20px;
}

.form-group label {
    width: 150px;
    margin-right: 30px;
    text-align: right;
    margin-bottom: 0px;
    margin-top: 9px;
}

.form-group input.form-control,
.form-group select.form-control {
    flex: 1;
    width: auto;
    margin-left: 0;
    margin-bottom: 0px;
    height: 40px;
}

.checkbox-container {
    display: flex;
    gap: 30px;
    align-items: center;
}

.checkbox-item {
    display: flex;
    align-items: center;
    gap: 6px;
}

.checkbox-item input {
    width: auto;
    height: auto;
}

.artificial-fieldset-steps {
  border: 1px solid #8b8b8b;
  padding: 30px 10px 10px 10px;
  margin: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  width: 96%;
}

.legend-wrapper {
  float: left;
  margin-top: -42px;
  margin-left: 10px;
  background-color: #e4e4e4;
  border: 1px solid #8b8b8b;
  border-radius: 3px;
}

.artificial-fieldset-steps-legend {
  font-size: 14px;
  font-weight: bold;
  padding: 2px 8px;
}

span {
  border: 0px;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
}
</style>